/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AdminSelect } from '@project/components';
import axios from '../../utils/axios';
import Axios, { CancelToken } from 'axios';
import { useIntl } from 'react-intl';

// hook for retrieving companies
const useFetchCompanies = () => {

  const [companies, setCompanies] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchCompanies = async () => {
      const source = CancelToken.source();

      try {
        const result = await axios.get('/companies', { cancelToken: source.token });
        const companyOptions = result.data.data
          .map((record) => ({ value: record.name, label: record.displayName || record.name, slug: record.slug }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setCompanies(companyOptions);
        setIsLoading(false);
      } catch (e) {

        if (Axios.isCancel(e)) {
          // request is cancelled
        } else {
          throw e;
        }
      }
    }
    setIsLoading(true);
    fetchCompanies();

    return () => {
      CancelToken.source().cancel();
    }
  }, []);

  return { companies, isLoading };
}

function CompanySelect({ selectedCompany, setSelectedCompany, defaultCompany, attributes = [] }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const { companies, isLoading } = useFetchCompanies();

  useEffect(() => {
    if (companies && companies.length && defaultCompany) {
      let company = companies.find(_ => _.slug === defaultCompany);
      if (company) setSelectedCompany(company);
    }
  }, [defaultCompany, companies])

  return (
    <AdminSelect
      id="company-select"
      label={t('term.company')}
      placeholder={t('CompanySelect.placeholder')}
      value={selectedCompany}
      onChange={setSelectedCompany}
      isLoading={isLoading}
      loadingMessage={t('CompanySelect.loadingMessage')}
      noOptionsMessage={t('CompanySelect.noOptions')}
      options={companies}
      identifierClass={!isLoading ? 'data-company-select' : ''}
    />
  )
}

CompanySelect.propTypes = {
  selectedCompany: PropTypes.any,
  setSelectedCompany: PropTypes.func.isRequired
}

export default CompanySelect